import { useInfiniteQuery } from '@tanstack/react-query'
import {
  EParamChannelTypeGlobal,
  EReportColumnHeader,
  EReportingTimeWindow,
} from '@unfoldrtech/portal-mic/dist/src/models/core'

import { generateCorrelationId, getTimezone } from '../utils/helpers'
import {
  TDACampaignsReportTableFilters,
  TDOOHCampaignsReportTableFilters,
  TGenericCampaignsReportTableFilters,
  TPPRetailerId,
  TSPCampaignsReportTableFilters,
} from '../models/types'
import { coreAPIV3 } from '../services/coreAPIV3'

type TParams = (
  | TGenericCampaignsReportTableFilters
  | TSPCampaignsReportTableFilters
  | TDACampaignsReportTableFilters
  | TDOOHCampaignsReportTableFilters
) &
  TPPRetailerId & {
    enabled?: boolean
    pageLimit: number
    pageOffset: number
  }

export default function useGetRetailerReportingCampaignsTableV3({
  retailerId,
  advertiserId,
  channelType,
  sortBy,
  timeWindow,
  startDate,
  endDate,
  sortOrder,
  tzZone,
  pageLimit,
  pageOffset,
  filterBy,
  filterOperation,
  filterValue,
  name,
  status,
  enabled = true,
}: TParams) {
  const queryKeyName = `getRetailerReportingCampaignsTable_${channelType}_${retailerId}_${advertiserId}`

  return useInfiniteQuery({
    queryKey: [
      queryKeyName,
      { start: startDate, end: endDate, channelType, pageOffset, pageLimit },
    ],
    queryFn: ({ pageParam = { pageOffset: 0, pageLimit } }) => {
      return coreAPIV3.retailerReporting().getRetailerCampaignsReportTableV3(
        retailerId,
        generateCorrelationId(),
        advertiserId,
        channelType as EParamChannelTypeGlobal,
        sortBy as EReportColumnHeader,
        sortOrder,
        timeWindow as EReportingTimeWindow,
        startDate,
        endDate,
        tzZone || getTimezone(),
        pageLimit,
        pageParam.pageOffset,
        filterBy,
        filterOperation,
        filterValue,
        name,
        // @ts-expect-error: fix in PORT-2535
        status
      )
    },
    enabled,
    getNextPageParam: (_, allPages) => {
      const currentOffset = allPages.length * pageLimit

      // NB: reporting service does not send us total items available based on filters (not pagination)
      // therefore one way we decide to not call the endpoint is if the returned items is less than the page limit
      return { pageOffset: currentOffset, pageLimit }
    },
  })
}
